import View from '../../View'
import {AccessRights} from '../../constants'

export default class APAccessRightsChecker extends View {
    constructor() {
        super()

        this.state = {}
    }

    _hasRightRegardlessFeature(user, accessRight) {
        return user.accessRights.indexOf(accessRight) !== -1
    }

    hasManageUsersRight(user) {
        return this._hasRightRegardlessFeature(user, AccessRights.AP_MANAGE_GENERAL_SETTINGS)
    }

    hasManageSystemSettingsRight(user) {
        return this._hasRightRegardlessFeature(user, AccessRights.AP_MANAGE_GENERAL_SETTINGS)
    }
}


// WEBPACK FOOTER //
// ./web/js/util/productAccessRightsChecker/APAccessRightsChecker.js